import { useIntl } from 'react-intl';

import { ChatMessage as ChatMessageType } from '@/hooks/emotion-detector/useEmotionChat';

import { MessageBubble, MessageRow, MessageSender } from '../styles';
import { getSenderName } from '../utils';

interface ChatMessageProps {
	message: ChatMessageType;
	messageId: string;
}

export default function ChatMessage({ message, messageId }: ChatMessageProps) {
	const { formatMessage } = useIntl();
	const isUser = message.role === 'user';

	return (
		<MessageRow key={messageId} isUser={isUser}>
			<MessageBubble isUser={isUser}>
				<MessageSender>{getSenderName(message.role, formatMessage)}</MessageSender>
				{message.content}
			</MessageBubble>
		</MessageRow>
	);
}
